import axios from "axios";

export const getFeaturedGroups = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredgroups/getGroups/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const addFeaturedGroup = (json) => {
  return axios
    .post(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/featuredgroups/addGroup",
      json
    )
    .then((res) => res.data);
};

export const editFeaturedGroup = (json) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/featuredgroups/editGroup",
      json
    )
    .then((res) => res.data);
};

export const deleteFeaturedGroup = (groupId) => {
  return axios
    .delete(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredgroups/deleteGroup/" +
        encodeURIComponent(groupId)
    )
    .then((res) => res);
};

export const updateFeaturedGroupOrder = (careersClientId, newOrder) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/featuredgroups/updateOrder/" +
        encodeURIComponent(careersClientId),
      newOrder
    )
    .then((res) => res.data);
};
